import styled from "styled-components";

export const Form = styled.form`
  width: inherit;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 20px 15px;
`;

export const FormHeader = styled.div`
  display: inline-flex;
  width: inherit;
  align-content: center;
  justify-content: space-between;

  button {
    margin: 0;
    padding: 0 20px;
    height: 2.5rem;
  }

  @media (max-width: 770px) {
    button {
      width: auto !important;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${(props) => (props.isDate === true ? `10px` : `20px`)};
  width: inherit;

  label {
    width: 20%;
    font-size: 1rem;
  }

  select {
    margin-bottom: 0 !important;
  }

  @media (max-width: 760px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: ${(props) => (props.isDate === true ? `10px` : `30px`)};

    input,
    input[type="date"],
    input[type="number"],
    input[type="float"],
    select {
      width: 100%;
      font-size: 1.1rem;
    }

    input[type="radio"],
    input[type="checkbox"] {
      width: auto;
      transform: scale(1.4) !important;
      margin-left: 2px;
    }
  }
`;

export const RowOption = styled(Row)`
  justify-content: left;
  align-items: center;
  margin-top: 0;
  ${(props) => props.isOptionRadio && `margin-bottom: 5px;`}

  input {
    margin-right: 10px;
  }

  label {
    width: inherit;
  }

  @media (max-width: 760px) {
    flex-direction: row;
    align-items: center;

    label {
      margin-bottom: 0;
    }
  }
`;

export const RowSpecific = styled(Row)`
  align-items: flex-start;
  margin: 5px 0;
`;

export const RowDetails = styled(Row)`
  width: auto;
  margin-bottom: 2px;

  input {
    margin-right: 10px;
  }

  div {
    align-items: center;
    margin: 0;
  }

  div label {
    width: 100%;
  }

  @media (max-width: 760px) {
    input[type="number"] {
      margin-bottom: 10px;
    }
  }

  @media (max-width: 570px) {
    width: inherit;

    button + input[type="number"] {
      margin: 0;
    }
  }
`;

export const RowDetailsTotal = styled(RowDetails)`
  margin-bottom: 10px;

  @media (max-width: 760px) {
    span {
      align-self: center !important;
    }
    margin-bottom: 30px;
    div {
      margin-top: 10px;
    }
  }
`;

export const RowValueButtons = styled(Row)`
  @media (max-width: 570px) {
    flex-direction: row;
    margin-bottom: 0 !important;
    width: 100%;

    + div {
      margin-top: 20px;
    }

    input[type="number"] {
      align-self: center;
      width: inherit;
    }
  }
`;

export const RowButtonsStep = styled(Row)`
  justify-content: space-between;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: inherit;

  ${(props) => props.isColumnDate && `margin-bottom: 50px;`}

  label {
    width: 20%;
    font-size: 1rem;
  }

  textarea {
    width: inherit;
    min-height: 10rem;
    margin-bottom: 20px;
  }
`;

export const Label = styled.label`
  color: #212529;
  margin-bottom: 0;

  ${(props) => props.isBold && `font-weight: bold;`}

  @media( max-width: 760px ) {
    width: max-content !important;
    margin-bottom: 10px;
  }

  @media (max-width: 500px) {
    font-size: 1.1rem !important;
  }
`;

export const InputDate = styled.input`
  :disabled {
    background: #eee;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.span`
  font-size: 1rem;
  font-weight: bold;
  font-style: italic;
  color: var(${(props) => props.color});
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin-bottom: 10px;

  ::before {
    display: inline;
    content: "⚠ ";
  }

  @media (max-width: 760px) {
    margin-bottom: 10px;
    text-align: center;
  }
`;

export const ButtonFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InfoMessage = styled.span`
  font-size: 1rem;
  font-weight: bold;
  font-style: italic;
  color: var(${(props) => props.color});
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin-bottom: 10px;
`;

